<template>
    <div style="width:100%;" class="pa-4 pb-6">
        <v-data-table
            :headers="headers"
            :items="provider_payment_items"
            hide-default-footer
        >
            <template v-slot:[`item.amount`]="{ item }">
                {{ parseFloat(item.amount).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
            </template>
            <template v-slot:[`item.due`]="{ item }">
                {{ parseFloat(item.due).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
            </template>
            <template v-slot:[`item.newDue`]="{ item }">
                {{ parseFloat(item.newDue).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="editItem(item)">
                    <v-icon small class="mr-2">mdi-pencil</v-icon> Editar
                    </v-list-item>
                    <v-list-item @click="item_to_delete = item, sheet = true">
                    <v-icon small class="mr-2">mdi-delete</v-icon> Eliminar
                    </v-list-item>
                </v-list>
                </v-menu>
            </template>
        </v-data-table>
    </div>  
</template>

<script>
export default {
    props:{
        provider_payment_items:Array
    },
    data(){
        return{
            headers: [
                { text: 'Compra', value: 'shopping_id',},
                { text: 'Deuda', value: 'due',},
                { text: 'Abono', value: 'amount',},
                { text: 'Pendiente', value: 'newDue',},
                { text: 'Factura', value: 'invoice',},
                { text: 'Fecha Vencimiento', value: 'due_date',},
                //{ text: '', value: 'actions',},
            ],
        }
    }
}
</script>

<style>

</style>